import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ShareIcon } from 'foundations-assets/icons/components/ShareIcon';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { FileButton } from 'foundations-components/transitional/components/FileButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { H3 } from 'foundations-components/transitional/components/H3';
import FileUploadComponent from 'FileManagerLib/components/upload/FileUploadComponent';
import { FileExtensionFilterEnum } from 'FileManagerLib/enums/FileExtensionFilters';
import { DropZoneNoBrowseFileAccess } from 'FileManagerLib/enums/FileAccess';
import { createBuyerLogoUploadClient } from '../../api/buyerLogoUpload';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACCEPTED_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
function FileUploadContent({
  handleUploadClick
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    padding: "300",
    flexDirection: "column",
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(ShareIcon, {
      color: "icon-core-subtle",
      size: "600"
    }), /*#__PURE__*/_jsxs(Text, {
      textAlign: "center",
      typography: "body-100",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealPlan.header.buyerBrandLogo.dragDropText"
      }), ' ', /*#__PURE__*/_jsx(FileButton, {
        use: "link",
        onChange: handleUploadClick
        // @ts-ignore - override color prop
        ,
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealPlan.header.buyerBrandLogo.chooseFileText"
        })
      })]
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealPlan.header.buyerBrandLogo.supportedFileTypes"
      })
    })]
  });
}
export default function LogoUploadModal({
  dealPlanId,
  onUpload,
  onClose
}) {
  const httpClient = useMemo(() => createBuyerLogoUploadClient(dealPlanId), [dealPlanId]);
  const handleUploadedUrlChange = useCallback(url => {
    if (url) {
      onUpload(url);
    }
  }, [onUpload]);
  return /*#__PURE__*/_jsx(Modal, {
    width: 448,
    children: /*#__PURE__*/_jsxs(DialogBody, {
      padding: "600",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(H3, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dealPlan.header.buyerBrandLogo.uploadTitle"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(FileUploadComponent
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      , {
        _httpClient: httpClient,
        uploadedFileAccess: DropZoneNoBrowseFileAccess.HIDDEN_IN_APP_PUBLIC_TO_ALL_INDEXABLE,
        onChange: handleUploadedUrlChange,
        uploadButtonRenderer: handleUploadClick => /*#__PURE__*/_jsx(FileUploadContent, {
          handleUploadClick: handleUploadClick
        }),
        filterType: FileExtensionFilterEnum.SUPPORTED,
        filteredExtensions: ACCEPTED_IMAGE_EXTENSIONS,
        size: "small"
      })]
    })
  });
}